// extracted by mini-css-extract-plugin
export default {"container":"C50zE2Jq7_MqM__aI2rQ","titleRow":"t7YlLzU1Zd7yEsRnD3Gf","iconContainer":"broynB5Ct_v2a5SOgBLg","titleText":"c6u2lenoOYZ77aNA0now","findOutMore":"baeCHQ5P7WhKC5elQbmg"};